<template>      
  <div class="wrapper">
    <div class="md-layout">
      <div class="md-layout-item md-size-95 mx-auto md-small-size-100 navbar-margin-carousel">
        <md-card class="startPageCarousel">
          <carousel 
            :per-page="1"
            loop
            :speed="700"
            autoplay
            :autoplay-timeout="8000"
            :mouse-drag="false"
            navigationEnabled
            navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
            navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>"
          >
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Alu-Zaun/'">
                  Aluminium-Zäune
                </router-link>
              </div>
              <img :src="carousel1"/>
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Balkon/'">
                  Balkongeländer
                </router-link>
              </div>
              <img :src="carousel2" />
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Sichtschutz/'">
                  Sichtschutzwände
                </router-link>
              </div>
              <img :src="carousel3" />
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Stahlzaun/'">
                  Stahl-Zäune
                </router-link>
              </div>
              <img :src="carousel4" />
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Alu-Zaun/'">
                  Aluminum-Zäune
                </router-link>
              </div>
              <img :src="carousel5" />
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Balkon/'">
                  Balkonverkleidungen
                </router-link>
              </div>
              <img :src="carousel6" />
            </slide>
            <slide>
              <div class="carousel-caption">
                <router-link :to="'/produkte/Sichtschutz/'">
                  Sichtschutzwände
                </router-link>
              </div>
              <img :src="carousel7" />
            </slide>
          </carousel>
        </md-card>
      </div> 
    </div>
  </div>  
</template>

<script>
export default {
  name: 'Startseite',
  props: {
    msg: String
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      carousel1: require("@/assets/slider_images/zaun2.png"),
      carousel2: require("@/assets/slider_images/balkon1.png"),
      carousel3: require("@/assets/slider_images/sichtschutz1.png"),
      carousel4: require("@/assets/slider_images/Stahl-Zäune1.png"),
      carousel5: require("@/assets/slider_images/zaun1.png"),
      carousel6: require("@/assets/slider_images/balkon2.png"),
      carousel7: require("@/assets/slider_images/sichtschutz2.png")
    }
  },
  methods: {
    onResponsiveInverted() {
      if (window.innerWidth < 600) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->